import { useLayoutEffect, useState } from 'react';
import { APP_ID } from '@/utils';

const MIN_KEYBOARD_HEIGHT = 300;

export const useKeyboard = () => {
  const [isOpenKeyboard, setIsOpenKeyboard] = useState(false);

  useLayoutEffect(() => {
    const $app = document.getElementById(APP_ID);

    if (!$app) {
      return;
    }

    const onFocus = () => {
      setIsOpenKeyboard(window.screen.height - MIN_KEYBOARD_HEIGHT > (window.visualViewport?.height || 0));
    };

    const onHideKeyboard = () => {
      setIsOpenKeyboard(false);
    };

    const allInputs = $app.querySelectorAll('input, textarea');

    allInputs.forEach((input) => {
      input.addEventListener('focusin', onFocus);
      input.addEventListener('focus', onFocus);
      input.addEventListener('blur', onHideKeyboard);
      input.addEventListener('focusout', onHideKeyboard);
    });

    window.visualViewport?.addEventListener('resize', onFocus);
    return () => {
      allInputs.forEach((input) => {
        input.removeEventListener('focusin', onFocus);
        input.removeEventListener('focus', onFocus);
        input.removeEventListener('blur', onHideKeyboard);
        input.removeEventListener('focusout', onHideKeyboard);
      });

      window.visualViewport?.removeEventListener('resize', onFocus);
    };
  }, []);

  return { isOpenKeyboard };
};
